var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Seminar Outline")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document on Google Doc and replace all the highlighted fields with relevant information pertaining to your seminar. When finished, please submit a sharing link (with editing enabled) below so we can help edit and comment on the document. "
        )
      ]),
      _c(
        "Button",
        {
          staticClass: "btn-download mt-20",
          attrs: { skin: "grey" },
          on: { click: _vm.handleClickDownload }
        },
        [_vm._v("Seminar Outline Template")]
      ),
      _c("p", { staticClass: "text mt-30 bold big" }, [
        _vm._v("Please paste your outline sharing link here and click submit")
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap large mt-20" },
        [
          _c("Input", {
            attrs: { label: "Http link", value: _vm.value.link },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "link")
              }
            }
          })
        ],
        1
      ),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }